// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table-module__tableWrapper--ARQW0"};